var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Quickbuy = (function (Quickbuy) {
        var QuickbuyList = {}, initialSelectColorText, initialSelectSizeText, initialSelectDim3Text;

        Quickbuy.addToQuickbuyList = function (productsList, parse) {
            var color;
            for (var n = 0; n < productsList.length; n++) {    
                if (parse) {
                    productsList[n].Dimensionsjson = JSON.parse(productsList[n].Dimensionsjson);
                    productsList[n].FinalSkuPrices = productsList[n].Fields.FinalSkuPrices;
                }

                if (!productsList[n].Dimensionsjson)
                    continue;

                //get color
                color = "";
                if (productsList[n].Color) {
                    color = "-" + productsList[n].Color;
                } else if (productsList[n].DefaultColorId) {
                    color = "-" + productsList[n].DefaultColorId;
                }

                //update Dimensionsjson - set sku prices from PricesBySku
                productsList[n].Dimensionsjson.SkuList.Skus.forEach(function (item) {

                    //get skus from object PricesBySku
                    var skus = Object.keys(productsList[n].FinalSkuPrices);
                    //get selected sku for PricesBySku object
                    var selectedSku = skus.find(function (x) { return item.SkuData.SkuId.toString() === x });
                    //update prices
                    if (selectedSku) {
                        item.SkuData.UnitPrice = productsList[n].FinalSkuPrices[selectedSku].DisplayPrice.Display;
                        item.SkuData.DeletedPrice = productsList[n].FinalSkuPrices[selectedSku].DisplayDeletedPrice.Display;
                        item.SkuData.DiscountPercentage = productsList[n].FinalSkuPrices[selectedSku].Discount.Display;
                        item.SkuData.QuantityPrices = productsList[n].FinalSkuPrices[selectedSku].QuantityPrices;
                    }
                }); 

                QuickbuyList[productsList[n].Id + color] = productsList[n].Dimensionsjson;
            }
        };

        Quickbuy.Update = function ($wrapper, model, partial) {
            var html = Vendd.Handlebars.parse(partial, model);
            $wrapper.html(html);
        };

        Quickbuy.initState = function (productId, defaultColor) {

            var newState = {}, state;

            var customId = productId;
            if (defaultColor) {
                customId = productId + "-" + defaultColor;
            }

            state = GetDimJson(customId);

            if (state == null) return;

            newState.Colors = state.Colors;
            newState.Sizes = state.Sizes;
            newState.Dim3 = state.Dim3;

            newState.HasColors = state.SkuList.HasColors && state.Colors[0].Id != 0;
            newState.HasSizes = state.SkuList.HasSizes && state.Sizes[0].Id != 0;
            newState.HasDim3 = state.SkuList.HasDim3 && state.Dim3[0].Id != 0;

            newState.HasSingleColor = (state.Colors.length == 1 && state.Colors[0].Id != 0) ? true : false;
            newState.HasSingleSize = (state.Sizes.length == 1 && state.Sizes[0].Id != 0) ? true : false;
            newState.HasSingleDim3 = (state.Dim3.length == 1 && state.Dim3[0].Id != 0) ? true : false;

            newState.HasSingleDim = (newState.HasColors && !newState.HasSizes && !newState.HasDim3) || (!newState.HasColors && newState.HasSizes && !newState.HasDim3) || (!newState.HasColors && !newState.HasSizes && newState.HasDim3);
            newState.HasTwoDims = (newState.HasColors && newState.HasSizes && !newState.HasDim3) || (newState.HasColors && !newState.HasSizes && newState.HasDim3) || (!newState.HasColors && newState.HasSizes && newState.HasDim3);
            newState.HasThreeDims = newState.HasColors && newState.HasSizes && newState.HasDim3;

            newState.SizeDisabled = false;
            newState.Dim3Disabled = false;
            newState.ColorSelected = false;
            newState.SizeSelected = false;
            newState.Dim3Selected = false;

            newState.SelectColorText = state.SelectColorText;
            newState.SelectSizeText = state.SelectSizeText;
            newState.SelectDim3Text = state.SelectDim3Text;
            newState.NoAvailableSizesText = state.NoAvailableSizesText;
            newState.NoAvailableDim3Text = state.NoAvailableDim3Text;

            initialSelectColorText = state.SelectColorText;
            initialSelectSizeText = state.SelectSizeText;
            initialSelectDim3Text = state.SelectDim3Text;

            newState.InitialSelectColorText = initialSelectColorText;
            newState.InitialSelectSizeText = initialSelectSizeText;
            newState.InitialSelectDim3Text = initialSelectDim3Text;

            //check cases for new state
            newState.defaultDimId = null;
            newState.createNewColorState = false;
            newState.createNewSizeState = false;
            newState.createNewDim3State = false;

            if (newState.HasColors) {
                if (newState.HasSingleDim || newState.HasSingleColor) {
                    newState.createNewColorState = true;
                    if (newState.HasSingleColor) {
                        newState.defaultDimId = newState.Colors[0].Id;
                    }
                }
            } else {
                if (newState.HasSizes) {
                    if (newState.HasSingleDim || newState.HasSingleSize) {
                        newState.createNewSizeState = true;
                        if (newState.HasSingleSize) {
                            newState.defaultDimId = newState.Sizes[0].Id;
                        }
                    }
                } else {
                    if (newState.HasDim3) {
                        if (newState.HasSingleDim || newState.HasSingleDim3) {
                            newState.createNewDim3State = true;
                            if (newState.HasSingleDim3) {
                                newState.defaultDimId = newState.Dim3[0].Id;
                            }
                        }
                    }
                }
            }

            return newState;
        };

        Quickbuy.createNewState = function (wrapper, dimId, productId, defaultColor, type) {
            var availableDimList;

            var customId = productId;
            if (defaultColor) {
                customId = productId + "-" + defaultColor;
            }

            var json = GetDimJson(customId); 
            var skus = json.SkuList.Skus;
            var state = wrapper.model;

            if (type === 'color') {

                UpdateSelectedItems(state, dimId, type);
                
                wrapper.SelectedColorId = dimId;

                if (!state.HasSingleSize)
                    wrapper.SelectedSizeId = null;
                if (!state.HasSingleDim3)
                    wrapper.SelectedDim3Id = null;

                if (state.HasSizes) {
                    //get available sizes based on color
                    availableDimList = state.Colors.filter(function (x) { return x.Id === dimId })[0].AvailableSizes;

                    //create an object in order to store sizes
                    state.Sizes = [];
                    availableDimList.forEach(function (dim) { state.Sizes.push(json.Sizes.find(function (x) { return x.Id === dim })) });

                    //set single size as selected
                    if (state.Sizes.length === 1)
                        wrapper.SelectedSizeId = state.Sizes[0].Id;

                    //check for disabled dimensions
                    state.SizeDisabled = true;
                    for (var i = 0; i < state.Sizes.length; i++) {
                        state.Sizes[i].IsSelected = false;

                        for (var j = 0; j < skus.length; j++) {
                            if (skus[j].ColorId == dimId && skus[j].SizeId == state.Sizes[i].Id) { 
                                state.Sizes[i].Disabled = !(skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder);

                                if (state.SizeDisabled && (skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder)) {
                                    state.SizeDisabled = false;
                                }
                            }
                        }
                    }
                } else if (state.HasDim3) {
                    //get available dim3 based on color
                    availableDimList = state.Colors.filter(function (x) { return x.Id === dimId })[0].AvailableDim3;

                    //create an object in order to store dim3
                    state.Dim3 = [];
                    availableDimList.forEach(function (dim) { state.Dim3.push(json.Dim3.find(function (x) { return x.Id === dim })) });

                    //set single dim3 as selected
                    if (state.Dim3.length === 1)
                        wrapper.SelectedDim3Id = state.Dim3[0].Id;

                    //check for disabled dimensions
                    state.Dim3Disabled = true;
                    for (var i = 0; i < state.Dim3.length; i++) {
                        state.Dim3[i].IsSelected = false;

                        for (var j = 0; j < skus.length; j++) {
                            if (skus[j].ColorId == dimId && skus[j].Dim3Id == state.Dim3[i].Id) {
                                state.Dim3[i].Disabled = !(skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder);

                                if (state.Dim3Disabled && (skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder)) {
                                    state.Dim3Disabled = false;
                                }
                            }
                        }
                    }

                } else {
                    //check for disabled colors
                    state.ColorDisabled = true;
                    for (var i = 0; i < state.Colors.length; i++) {
                        for (var j = 0; j < skus.length; j++) {
                            if (skus[j].ColorId == state.Colors[i].Id) {
                                state.Colors[i].Disabled = !(skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder);

                                if (state.ColorDisabled && (skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder)) {
                                    state.ColorDisabled = false;
                                }
                            }
                        }
                    }
                }
                

            } else if (type === 'size') {

                UpdateSelectedItems(state, dimId, type);

                wrapper.SelectedSizeId = dimId;

                if (!state.HasSingleDim3)
                    wrapper.SelectedDim3Id = null;

                if (state.HasDim3) {
                    //get available dim3 based on size
                    availableDimList = state.Sizes.filter(function (x) { return x.Id === dimId })[0].AvailableDim3s;

                    //create an object in order to store dim3
                    state.Dim3 = [];
                    if (state.HasThreeDims) {
                        for (var i = 0; i < availableDimList.length; i++) {
                            var Dim3Arr = json.Dim3.find(function (x) { return x.Id === availableDimList[i] });
                            //loop each sku in order to insert only the available dim3 based on selected color and size
                            for (var j = 0; j < skus.length; j++) {
                                if (state.HasThreeDims && skus[j].ColorId == wrapper.SelectedColorId && skus[j].SizeId == dimId && skus[j].Dim3Id == Dim3Arr.Id) {
                                    state.Dim3.push(Dim3Arr);
                                }
                            }
                        }
                    } else {
                        availableDimList.forEach(function (dim) { state.Dim3.push(json.Dim3.find(function (x) { return x.Id === dim })) });
                    }

                    //set single dim3 as selected
                    if (state.Dim3.length === 1)
                        wrapper.SelectedDim3Id = state.Dim3[0].Id;

                    //check for disabled dimensions
                    state.Dim3Disabled = true;
                    for (var i = 0; i < state.Dim3.length; i++) {
                        state.Dim3[i].IsSelected = false;

                        for (var j = 0; j < skus.length; j++) {
                            if ((state.HasThreeDims && skus[j].ColorId == wrapper.SelectedColorId && skus[j].SizeId == dimId && skus[j].Dim3Id == state.Dim3[i].Id) ||
                                (state.HasTwoDims && skus[j].SizeId == dimId && skus[j].Dim3Id == state.Dim3[i].Id))
                            {
                                state.Dim3[i].Disabled = !(skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder);

                                if (state.Dim3Disabled && (skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder)) {
                                    state.Dim3Disabled = false;
                                }
                            }
                        }
                    }
                } else {
                    //check for disabled sizes
                    state.SizeDisabled = true;
                    for (var i = 0; i < state.Sizes.length; i++) {
                        for (var j = 0; j < skus.length; j++) {
                            if ((state.HasColors && skus[j].ColorId == wrapper.SelectedColorId && skus[j].SizeId == state.Sizes[i].Id)
                                || (!state.HasColors && skus[j].SizeId == state.Sizes[i].Id)) {

                                state.Sizes[i].Disabled = !(skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder);

                                if (state.SizeDisabled && (skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder)) {
                                    state.SizeDisabled = false;
                                }
                            }
                        }
                    }
                }

            } else if (type === 'dim3') {

                UpdateSelectedItems(state, dimId, type);
                wrapper.SelectedDim3Id = dimId;

                //check for disabled dim3
                state.Dim3Disabled = true;
                for (var i = 0; i < state.Dim3.length; i++) {
                    for (var j = 0; j < skus.length; j++) {
                        if ((state.HasThreeDims && skus[j].ColorId == wrapper.SelectedColorId && skus[j].SizeId == wrapper.SelectedSizeId && skus[j].Dim3Id == state.Dim3[i].Id)
                            || (state.HasSizes && skus[j].SizeId == wrapper.SelectedSizeId && skus[j].Dim3Id == state.Dim3[i].Id)
                            || (!state.HasColors && !state.HasSizes && skus[j].Dim3Id == state.Dim3[i].Id)) {

                            state.Dim3[i].Disabled = !(skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder);

                            if (state.Dim3Disabled && (skus[j].SkuData.CanBuy || skus[j].SkuData.CanPreorder)) {
                                state.Dim3Disabled = false;
                            }
                        }
                    }
                }
            }

            return state;
        };

        Quickbuy.GetSkuData = function (wrapper, productId, defaultColor, colorId, sizeid, dim3id) {
            var state = wrapper.model;

            var customId = productId;
            if (defaultColor) customId = productId + "-" + defaultColor;

            var product = GetDimJson(customId);

            if (product == null)
                return null;

            var skuData;

            if (state.HasSingleDim) {
                if (state.HasColors) {
                    skuData = product.SkuList.Skus.find(function (x) { return x.ColorId === colorId });
                } else if (state.HasSizes) {
                    skuData = product.SkuList.Skus.find(function (x) { return x.SizeId === sizeid });
                } else if (state.HasDim3) {
                    skuData = product.SkuList.Skus.find(function (x) { return x.Dim3Id === dim3id });
                }
            }

            if (state.HasTwoDims) {
                if (state.HasColors && state.HasSizes) {
                    skuData = product.SkuList.Skus.find(function (x) { return x.ColorId === colorId && x.SizeId === sizeid });
                } else if (state.HasColors && state.HasDim3) {
                    skuData = product.SkuList.Skus.find(function (x) { return x.ColorId === colorId && x.Dim3Id === dim3id });
                } else if (state.HasSizes && state.HasDim3) {
                    skuData = product.SkuList.Skus.find(function (x) { return x.SizeId === sizeid && x.Dim3Id === dim3id });
                }
            }

            if (state.HasThreeDims) {
                skuData = product.SkuList.Skus.find(function (x) { return x.ColorId === colorId && x.SizeId === sizeid && x.Dim3Id === dim3id });
            }

            return skuData;
        };

        var GetDimJson = function (productId) {
            return ($.isEmptyObject(QuickbuyList)) ? null : QuickbuyList[productId];
        };

        var UpdateSelectedItems = function (state, dimId, type) {
            var arr;

            if (type === 'color') {
                arr = state.Colors;
            } else if (type === 'size') {
                arr = state.Sizes;
            } else if (type === 'dim3') {
                arr = state.Dim3;
            }

            for (var i = 0; i < arr.length; i++) {
                arr[i].IsSelected = false;

                if (arr[i].Id === dimId) {
                    arr[i].IsSelected = true;
                    if (type === 'color') {
                        state.SelectColorText = arr[i].Name;
                        state.SelectSizeText = initialSelectSizeText;
                        state.SelectDim3Text = initialSelectDim3Text;
                        state.ColorSelected = true;
                        state.SizeSelected = false;
                    } else if (type === 'size') {
                        state.SelectSizeText = arr[i].Name;
                        state.SelectDim3Text = initialSelectDim3Text;
                        state.SizeSelected = true;
                        state.Dim3Selected = false;
                    } else if (type === 'dim3') {
                        state.SelectDim3Text = arr[i].Name;
                        state.Dim3Selected = true;
                    }
                }
            }
        };

        return Quickbuy;

    })(Vendd.Quickbuy || {});


    return Vendd;

})(Vendd || {});